(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('ColheitasCtrl', ColheitasCtrl);

  ColheitasCtrl.$inject = [
    '$q',
    '$location',
    '$scope',
    '$rootScope',
    '$routeParams',
    'LoadingService',
    'ColheitaService',
    'AtividadesService',
    'Flash'
  ];

  // eslint-disable-next-line max-lines-per-function,max-params
  function ColheitasCtrl($q, $location, $scope, $rootScope, $routeParams,
    LoadingService, ColheitaService,
    AtividadesService, Flash) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.colheitas = [];
    vm.atividades = [];
    vm.colheita = null;
    vm.filters = {};

    const error = function() {
      Flash.create(FALHA_AO_CONSULTAR_REGISTRO.type, FALHA_AO_CONSULTAR_REGISTRO.msg);
      $location.path('/colheitas');
    };

    //////////////////////////////////////////
    // Function declarations
    vm.show = function(index) {
      vm.colheita = vm.colheitas[index];
      if (vm.colheita) {
        $location.path(`/colheitas/${vm.colheita.id}`);
      }
    };

    vm.new = function() {
      $location.path('/colheitas/new');
    };

    vm.search = function() {
      LoadingService.showLoading();
      ColheitaService.list(vm.filters).then(function(data) {
        vm.colheitas = data.data || [];
      }, error)
        .finally(LoadingService.hideLoading);
    };

    vm.isCana = function(colheita) {
      return AtividadesService.isCana(_.get(colheita, 'atividade.descricao'));
    };

    //////////////////////////////////////////
    // Controller logic
    const init = function() {
      const promises = [
        AtividadesService.listComEmpreendimento(),
        ColheitaService.list(vm.filters)
      ];

      if ($routeParams.id) {
        ColheitaService.list($routeParams.id).then(function(data) {
          vm.colheita = data.data || {};
          LoadingService.hideLoading();
          if (!vm.colheita.id) {
            error();
          }
        }, error);
      } else {
        $q.all(promises).then(function(data) {
          vm.atividades = data[0].data || [];
          vm.colheitas = data[1].data || [];

          vm.colheitas.forEach((colheita) => {
            colheita.total_colhido_ton = colheita.total_colhido_kg / 1000;
          });

          vm.glebas = $rootScope.currentPropriedade.glebas;
          LoadingService.hideLoading();
        })
          .catch(error);
      }
    };

    const initialize = function() {
      LoadingService.showLoading();
      $rootScope.initialize.then(function() {
        vm.filters.safra = $rootScope.safras.filter(function(safra) {
          return safra.current;
        })[0];
        vm.filters.propriedade = $rootScope.currentPropriedade;

        if ($scope.$root.parametros.nao_cliente_agrogestao && $rootScope.permissions.colheitas.canRead) {
          init();
        } else {
          $location.path('/');
          Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        }
      }, $rootScope.errorRootInitialize).finally(LoadingService.hideLoading);
    };

    initialize();
  }
}());
